export type LeadImportArea = 'platform' | 'tenant';

export type LeadImportFieldKey =
  | 'fullName'
  | 'phoneNumber'
  | 'email'
  | 'preferredDestination'
  | 'leadSource'
  | 'ownerDisplayName'
  | 'whatsappNumber'
  | 'city'
  | 'state'
  | 'country'
  | 'qualification'
  | 'percentageOrCgpa'
  | 'passingYear'
  | 'institution'
  | 'preferredCourse'
  | 'intake'
  | 'budgetRange'
  | 'passportStatus'
  | 'englishTestStatus'
  | 'loanRequired'
  | 'stream'
  | 'section'
  | 'message'
  | 'campaignName'
  | 'adSetName'
  | 'utmSource'
  | 'utmMedium'
  | 'utmCampaign'
  | 'utmTerm'
  | 'utmContent';

export const LEAD_IMPORT_IGNORE = '__ignore__';
export const LEAD_IMPORT_NOT_MAPPED = '__not_mapped__';

export type LeadImportFieldDefinition = {
  key: LeadImportFieldKey;
  label: string;
  required: boolean;
  synonyms: string[];
};

export type LeadImportColumnMapping = Record<string, LeadImportFieldKey | typeof LEAD_IMPORT_IGNORE | typeof LEAD_IMPORT_NOT_MAPPED>;

export type LeadImportParsedFile = {
  headers: string[];
  rows: Record<string, string>[];
  sampleRows: Record<string, string>[];
};

export type LeadImportRowStatus = 'valid' | 'warning' | 'error' | 'duplicate';

export type LeadImportDuplicateAction = 'skip' | 'update' | 'create';

export type LeadImportPreviewRow = {
  rowIndex: number;
  status: LeadImportRowStatus;
  fields: Record<string, string>;
  errors: string[];
  warnings: string[];
  existingLead?: {
    _id: string;
    fullName: string;
    email?: string;
    phoneNumber: string;
  };
  resolvedOwnerUserId?: string;
};

export type LeadImportPreviewAggregates = {
  total: number;
  valid: number;
  warning: number;
  duplicate: number;
  error: number;
};

export type LeadImportPreviewResult = {
  rows: LeadImportPreviewRow[];
  aggregates: LeadImportPreviewAggregates;
};

export type LeadImportErrorRow = {
  rowIndex: number;
  originalRow: Record<string, string>;
  reason: string;
  category: 'error' | 'warning' | 'duplicate' | 'runtime';
};

export type LeadImportExecuteResult = {
  total: number;
  created: number;
  updated: number;
  skippedDuplicates: number;
  skippedErrors: number;
  skippedWarnings: number;
  failed: number;
  errors: LeadImportErrorRow[];
};

export type LeadImportWizardStep =
  | 'upload'
  | 'mapping'
  | 'stream'
  | 'duplicate'
  | 'preview'
  | 'importing'
  | 'results';

export type LeadImportProgress = {
  processed: number;
  total: number;
};
